import React, { useState,useEffect  } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function PubBodyForm() {
  const navtologin = useNavigate();
  const [formData, setFormData] = useState({
    Name: "",
    Phone: "",
    Country: "",
    State: "",
    City: "",
    Address: "",
    Pin: "",
    Age: "",
    Password: "",
  });
  useEffect(() => {
  window.scrollTo(0, 0);
}, []);

  const [termsAccepted, setTermsAccepted] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false); // State for loading spinner

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const handleCheckboxChange = (e) => {
    setTermsAccepted(e.target.checked);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!termsAccepted) {
      toast.error("You must agree to the terms and conditions.", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    if (formData.Password !== confirmPassword) {
      toast.error("Passwords do not match.", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    setIsLoading(true); // Show loading spinner
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/submit-form`, formData);
      console.log(response.data);

      toast.success("Registration successful! You may now log in.", {
        position: "top-right",
        autoClose: 3000,
      });

      setTimeout(() => {
        navtologin("/login");
      }, 3000);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        toast.error(error.response.data.error, {
          position: "top-right",
          autoClose: 3000,
        });
      } else {
        toast.error("Error submitting form. Please try again.", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } finally {
      setIsLoading(false); // Hide loading spinner
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-50">
      <form className="form-group w-75" id="pubForm" onSubmit={handleSubmit}>
        
        <h4 className="text-center" >Please enter your correct information</h4>

        <label htmlFor="nameInput">Name</label>
        <input
          type="text"
          name="Name"
          id="nameInput"
          className="form-control mb-2"
          placeholder="type your name"
          onChange={handleChange}
          required
        />

        <label htmlFor="whnumInput">Whatsapp Number</label>
        <input
          type="tel"
          pattern="(\+?[0-9]{1,4})?[0-9]{10,14}"
          title="Please enter a valid whatsapp number."
          name="Phone"
          id="whnumInput"
          className="form-control mb-2"
          placeholder="+91XXXXXXXXXX"
          onChange={handleChange}
          required
        />

        <label htmlFor="contrInput">Country</label>
        <input
          name="Country"
          id="contrInput"
          className="form-control mb-2"
          placeholder="type your country"
          onChange={handleChange}
          required
        />

        <label htmlFor="stateInput">State</label>
        <input
          name="State"
          id="stateInput"
          className="form-control mb-2"
          placeholder="type your state"
          onChange={handleChange}
          required
        />

        <label htmlFor="DisregInput">District/Region/City</label>
        <input
          name="City"
          id="DisregInput"
          className="form-control mb-2"
          placeholder="type your city/district/region"
          onChange={handleChange}
          required
        />

        <label htmlFor="addressInput">Delivery Address</label>
        <textarea
          name="Address"
          rows="3"
          id="addressInput"
          className="form-control mb-2"
          placeholder="enter your street address"
          onChange={handleChange}
          required
        />

        <label htmlFor="pincodeInput">Pincode</label>
        <input
          type="text"
          pattern="[0-9]{6}"
          title="Please enter a valid 6-digit pincode."
          name="Pin"
          id="pincodeInput"
          className="form-control mb-2"
          placeholder="XXXXXX"
          onChange={handleChange}
          required
        />

        <label htmlFor="ageInput">Age</label>
        <input
          type="number"
          name="Age"
          id="ageInput"
          className="form-control mb-2"
          placeholder="type your age"
          min="0"
          onChange={handleChange}
          required
        />

        <label htmlFor="passwordInput">Password</label>
        <input
          type="password"
          name="Password"
          id="passwordInput"
          minLength="8"
          className="form-control mb-2"
          placeholder="type your password"
          onChange={handleChange}
          required
        />

        <label htmlFor="confirmPasswordInput">Confirm Password</label>
        <input
          type="password"
          id="confirmPasswordInput"
          minLength="8"
          className="form-control mb-2"
          placeholder="confirm your password"
          onChange={handleConfirmPasswordChange}
          required
        />

        <div className="form-check mb-3">
          <input
            type="checkbox"
            name="terms"
            id="termsCheckbox"
            className="form-check-input"
            onChange={handleCheckboxChange}
            required
          />
          <label htmlFor="termsCheckbox" className="form-check-label">
            I agree to the{" "}
            <Link to="/termsPage" className="text-decoration-none">
              terms and conditions
            </Link>{" "}
            and have read all the policies carefully.
          </label>
        </div>

        <div className="justify-content-center d-flex">
          <button
            type="submit"
            className="btn btn-success mt-4 mb-4 shadow text-center"
            disabled={isLoading}
          >
            {isLoading ? (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
            ) : null}
            {isLoading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>

      {/* Toast Container */}
      <ToastContainer />
    </div>
  );
}
